import React from "react";
import ReactDOM from "react-dom";

const NoteModal = ({ isOpen, onClose, notes }) => {
    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <div className="modal-overlay" onClick={onClose}>
            <div
                className="modal-content"
                onClick={e => e.stopPropagation()}
            >
                <div className="modal-header">
                    <h3>Policy Notes</h3>
                    <button className="close-button" onClick={onClose}>✕</button>
                </div>
                <div className="modal-body">
                    {Array.isArray(notes) && notes.length > 0 ? (
                        <table className="notes-table">
                            <thead>
                                <tr>
                                    <th>Date Requested</th>
                                    <th>Date Reviewed</th>
                                    <th>Date Resolved</th>
                                    <th>Note</th>
                                </tr>
                            </thead>
                            <tbody>
                                {notes.map((noteObj, idx) => (
                                    <tr key={idx}>
                                        <td>{noteObj.dateRequested || "—"}</td>
                                        <td>{noteObj.dateReviewed || "—"}</td>
                                        <td>{noteObj.dateResolved || "—"}</td>
                                        <td>{noteObj.notes || "—"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <p>No notes available for this record.</p>
                    )}
                </div>
            </div>
        </div>,
        document.body
    );
};

export default NoteModal;
